<template>
  <div>
    <div class="right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label>姓名</label>
            <input
              v-model="search.userName"
              class="form-control"
              type="text"
              placeholder
            />
          </div>
          <div class="form-group">
            <label>签到类型</label>
            <el-select v-model="search.type">
              <el-option label="签到" value="1"></el-option>
              <el-option label="签退" value="2"></el-option>
              <el-option label="全部" value="其它"></el-option>
            </el-select>
          </div>

          <div class="form-group">
            <label>考勤开始时间</label>
            <el-date-picker
              v-model="search.startTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
          <div class="form-group">
            <label>考勤结束时间</label>
            <el-date-picker
              v-model="search.endTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
          </div>
          <div class="form-group others">
            <button
              @click="downloadData"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              导出
            </button>
          </div>
        </form>
      </div>

      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column show-overflow-tooltip label=" 姓名" prop="userName">
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="考勤日期"
            prop="date"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="登录岗位"
            prop="areaNames"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="签到时间"
            prop="signInTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="签到地点"
            prop="signInAddress"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="签退时间"
            prop="signOutTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="签退地点"
            prop="signOutAddress"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="当班停车次数"
            prop="detectNum"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="下单次数"
            prop="orderNum"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="超过二十分钟未下单次数"
            prop="abnormalOrderNum"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="应收金额"
            prop="receivableAmount"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="实收金额"
            prop="amount"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="版本号"
            prop="version"
          ></el-table-column>

          <el-table-column label="行驶轨迹">
            <template slot-scope="$scope">
              <button
                @click="openMap($scope)"
                type="button"
                class="btn btn-primary"
              >
                查看地图
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
    <el-dialog
      title="轨迹回放"
      :visible.sync="dialogVisible"
      width="1300px"
      :show-close="false"
    >
      <p class="dialog-content">
        <span>姓名：{{ dialogData.name }}</span>
        <span>用户名：{{ dialogData.userName }}</span>
      </p>
      <p class="dialog-content">
        <span
          >签到时间：{{
            dialogData.signInTime ? dialogData.signInTime : "暂无"
          }}</span
        >
        <span
          >签退时间：{{
            dialogData.signOutTime ? dialogData.signOutTime : "暂无"
          }}</span
        >
      </p>
      <p>在线时长：{{ dialogData.time ? dialogData.time : "未知" }}</p>
      <div class="map-container">
        <div ref="dialog-map-container" class="dialog-map-container"></div>
        <div class="history-record">
          <ul>
            <li><span>时间</span><span>经纬度</span></li>
            <li
              v-for="(item, index) in dialogData.positionInfos"
              :key="index"
              @mouseover="handleMapMouseover(item)"
              @mouseleave="handleMapMouseleave(item)"
            >
              <span>{{ item.recoviceTime }}</span>
              <span>{{ item.position }}</span>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">关闭</el-button>
        <el-button type="primary" @click="playHistoryLocation"
          >播放轨迹</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import SearchParking from "../../commons/searchParking/index";

import { attendanceList, getHistoryLocation } from "@/api/url";

import Page from "../../commons/page";

// import ExportExcel from "../../commons/exportExcel.vue";

// import Refresh from "../../commons/refresh.vue";

import AreaTree from "../../commons/areaTree";

export default {
  data() {
    return {
      moduleName: "",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      treeData: {
        parkingId: "",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        // stationSn: "",
        type: "",
        userName: "",
        startTime: "",
        endTime: "",
      },
      tableListData: [],
      tableListDataTitle: [],
      tableListDataExcel: {},
      formLabelWidth: "100px",
      dialogFormVisible: false,
      dialogFormHeartTimeVisible: false,
      windows: new Map(),
      dialogVisible: false,
      dialogVisibleId: "",
      dialogData: {
        name: "",
        userName: "",
        signInTime: "",
        signOutTime: "",
        positions: [],
        positionInfos: [],
        time: "",
      },
      map: null,
      marker: null,
      infoMarker: null,
      infoWindow: null,
      infoMarkers: [],
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      //  if (!this.treeData.parkingId) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择道路"
      //   });
      //   return;
      // }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    // handleTreeClick: function(node, data) {
    //   this.search.name='';
    //   if (node.type != "parking") {
    //     // this.$message({
    //     // 	message: '请选择车场',
    //     // 	type: 'warning'
    //     // });
    //     return;
    //   } else {
    //     this.treeData.parkingId = node.id;
    //     this.search.pageNumber = 1;
    //     this.tableList(this.search.pageNumber);
    //   }
    // },
    tableList: function (curPage) {
      var _this = this;
      let parkingId, areaId;
      if (this.parking) {
        parkingId = this.parking.parkingId;
      }
      this.$get(attendanceList(), {
        limit: this.search.pageSize,
        page: curPage,
        userName: this.search.userName,
        type: this.search.type,
        startTime: this.search.startTime,
        endTime: this.search.endTime,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页

        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
        console.log(data.data.rows);
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["form"].resetFields();
    },
    searchList: function () {
      const { startTime, endTime } = this.search;
      var flTime = this.timeCompare(startTime, endTime);
      if (startTime && endTime && flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      }
      // else if (
      //   !Boolean(startTime) &&
      //   Boolean(endTime)
      // ) {
      //   return this.$layer.msg("请选择开始时间", { time: 1 });
      // } else if (
      //   Boolean(startTime) &&
      //   !Boolean(endTime)
      // ) {
      //   return this.$layer.msg("请选择结束时间", { time: 1 });
      // }
      // if (!this.treeData.parkingId) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择道路"
      //   });
      //   return;
      // }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function (bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.parkName = "";
    },
    downloadData() {
      console.log(this.search);
      const { userName, type, startTime, endTime } = this.search;
      this.$downloadFileRequest(
        "/api/parking/pdaAttendance/export",
        {
          userName,
          type,
          startTime,
          endTime,
        },
        "考勤"
      );
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.dialogData.name = "";
      this.dialogData.userName = "";
      this.dialogData.signInTime = "";
      this.dialogData.signOutTime = "";
      this.dialogData.positions = [];
      this.dialogData.positionInfos = [];
      this.dialogData.time = "";
    },
    playHistoryLocation() {
      if (this.marker) {
        this.marker.moveAlong(this.dialogData.positions, 200);
      }
    },
    openMap(scope) {
      const id = scope.row.id;
      this.dialogVisibleId = id;
      this.dialogVisible = true;
      this.$nextTick()
        .then(() => this.$get(getHistoryLocation(id)))
        .then((result) => {
          if (result.status === 200) {
            this.dialogData = result.data;
            const container = this.$refs["dialog-map-container"];

            this.map = new AMap.Map(container, {
              resizeEnable: true,
              center:
                this.dialogData.positions.length > 0
                  ? this.dialogData.positions[0]
                  : [116.478935, 39.997761],
              zoom: 17,
            });
            const map = this.map;
            this.marker = new AMap.Marker({
              map: map,
              position:
                this.dialogData.positions.length > 0
                  ? this.dialogData.positions[0]
                  : [116.478935, 39.997761],
              icon:
                "https://roadside-parking.oss-cn-shenzhen.aliyuncs.com/avatar/person2.png",
              offset: new AMap.Pixel(-26, -13),
              autoRotation: true,
              angle: -90,
            });

            var polyline = new AMap.Polyline({
              map: map,
              path: this.dialogData.positions,
              showDir: true,
              strokeColor: "#28F", //线颜色
              // strokeOpacity: 1,     //线透明度
              strokeWeight: 6, //线宽
              // strokeStyle: "solid"  //线样式
            });

            var passedPolyline = new AMap.Polyline({
              map: map,
              // path: lineArr,
              strokeColor: "#AF5", //线颜色
              // strokeOpacity: 1,     //线透明度
              strokeWeight: 6, //线宽
              // strokeStyle: "solid"  //线样式
            });

            this.marker.on("moving", function (e) {
              passedPolyline.setPath(e.passedPath);
            });
            map.setFitView();
          }
        });
    },
    handleMapMouseover(item) {
      const _this = this;
      this.infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
      this.infoMarker = new AMap.Marker({
        position: [item.lng, item.lat],
        map: _this.map,
      });

      this.infoMarker.setIcon('https://roadside-parking.oss-cn-shenzhen.aliyuncs.com/avatar/poi-marker.png');

      this.map.setFitView(this.infoMarker);
      this.infoWindow.setContent(`
      <span>定位时间：${item.recoviceTime}</span>
      <br/>
      <span>经度：${item.lng}</span>
      <br/>
      <span>纬度：${item.lat}</span>
      <br/>
      `);
      this.infoWindow.open(_this.map, this.infoMarker.getPosition());
      this.infoMarkers.push(this.infoMarker);
    },
    handleMapMouseleave(item) {
      if (this.infoWindow) {
        this.infoWindow.close();
      }
      if (this.map) {
        this.infoMarkers.forEach(mark => {
           this.map.remove(mark);
        });
        this.infoMarkers = [];
      }
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      parking: (state) => state.parking.oneParking,
    }),
  },
  components: {
    Page,
    // ExportExcel,
    // Refresh,
    AreaTree,
    SearchParking,
  },
  created: function () {},
  mounted: function () {
    this.tableList();
  },
  destroyed: function () {},
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;

  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
/* .edit,
.delete,
.chargingRules {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
} */
.chargingRules {
  width: 60px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fail,
.success,
.someSuccess {
  display: inline-block;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}
.fail {
  background: red;
  color: red;
}
.success {
  background: green;
  color: green;
}
.someSuccess {
  background: #ff6100;
  width: 65px;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 12px;
}
.lowerEquip {
  width: 60px;
  font-size: 12px;
  background: #409eff;
  color: white;
  height: 20px;
  line-height: 20px;
}
.refresh {
  display: inline-block !important;
}
.pow {
  text-align: left !important;
  padding-left: 1% !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  margin-left: -5%;
  border-radius: 1px;
}
.dialog-content {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
.dialog-content + p {
  font-size: 16px;
}
.dialog-map-container {
  width: 800px;
  height: inherit;
}
.map-container {
  box-sizing: border-box;
  padding-top: 20px;
  width: inherit;
  height: 420px;
  display: flex;
  justify-content: space-between;
}
.history-record {
  box-sizing: border-box;
  padding-left: 10px;
  flex: 1;
  height: inherit;
  overflow-x: hidden;
  overflow-y: auto;
}
.history-record::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.history-record::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.history-record::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.history-record ul {
  display: flex;
  flex-direction: column;
}
.history-record ul li {
  display: flex;
  justify-content: space-between;
  background-color: rgb(240, 240, 240);
  margin: 4px 0;
}
.history-record ul li:not(:first-child) {
  cursor: pointer;
}
.history-record ul li span {
  flex: 1;
  box-sizing: border-box;
  padding: 4px 0;
  text-align: center;
}
</style>

<style>
.amap-logo,
.amap-copyright {
  z-index: -1 !important;
}
</style>